import { MasterCropData, MasterUPCData } from '../types';

export interface MasterLabelPreviewIdentity {
  effectiveSource?: string;
  effectiveForgeOriginSource?: string;
  identityPromotedToForge: boolean;
}

function collectAllCrops(upc: MasterUPCData): MasterCropData[] {
  return [
    ...upc.designs.flatMap((design) => design.crops),
    ...(upc.pendingCrops ?? []),
    ...upc.unassignedCrops,
    ...upc.cartonCrops,
    ...(upc.inactiveCrops ?? []),
  ];
}

export function buildMasterLabelBaseCropLookup(upc?: MasterUPCData): Map<string, MasterCropData> {
  if (!upc) return new Map();
  return new Map(collectAllCrops(upc).map((crop) => [crop.id, crop]));
}

export function resolveMasterLabelPreviewIdentity(
  workingCrop: MasterCropData,
  baseCrop?: MasterCropData
): MasterLabelPreviewIdentity {
  if (!baseCrop || workingCrop.normalizedBarcode === baseCrop.normalizedBarcode) {
    return {
      effectiveSource: workingCrop.source,
      effectiveForgeOriginSource: workingCrop.forgeOriginSource,
      identityPromotedToForge: false,
    };
  }

  if (baseCrop.source === 'forge') {
    return {
      effectiveSource: workingCrop.source,
      effectiveForgeOriginSource: workingCrop.forgeOriginSource,
      identityPromotedToForge: false,
    };
  }

  return {
    effectiveSource: 'forge',
    effectiveForgeOriginSource: baseCrop.source,
    identityPromotedToForge: true,
  };
}

export function applyMasterLabelPreviewIdentity(
  workingCrop: MasterCropData,
  baseCrop?: MasterCropData
): MasterCropData {
  const previewIdentity = resolveMasterLabelPreviewIdentity(workingCrop, baseCrop);
  if (
    previewIdentity.effectiveSource === workingCrop.source &&
    previewIdentity.effectiveForgeOriginSource === workingCrop.forgeOriginSource
  ) {
    return workingCrop;
  }

  return {
    ...workingCrop,
    source: previewIdentity.effectiveSource,
    forgeOriginSource: previewIdentity.effectiveForgeOriginSource,
  };
}
